export default __webpack_public_path__ + "static/media/new_bell.b0402528.png";